import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Box,
  Container,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";
import {
  CheckCircle as CheckCircle,
  Cancel as CancelCircle,
} from "@mui/icons-material";

import { darkBg, lightBg2 } from "../../constants/colors";
import background from "../../assets/background.svg";
import Logo from "../../assets/home_logo_1.svg";

// APIs
import { verifyEmail } from "../../helpers/Authentication";

const EmailVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [response, setResponse] = useState("");

  useEffect(() => {
    handleVerify();
  }, []);

  const handleVerify = async () => {
    try {
      const paramValue = queryParams.get("token");
      const response = await verifyEmail(paramValue);
      if (response.isSuccess === true && response.statusCode === 200) {
        setResponse(response.message);
        setIsLoading(false);
        setIsSuccess(true);
      } else {
        setResponse(response.message);
        setIsLoading(false);
        setIsSuccess(false);
      }
    } catch (error) {
      setResponse(error.message);
      setIsLoading(false);
      setIsSuccess(false);
    }
  };

  return (
    // <Box
    //   style={{
    //     minHeight: "100vh",
    //     backgroundColor: "#000000",
    //     backgroundImage: `url(${background})`,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     // padding: { xs: 2, sm: 4 }
    //   }}
    // >
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        maxHeight: "100vh",
        width: "100%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "15px",
          top: "15px",
        }}
      >
        <img src={Logo} width={"100px"} height={"100px"} />
      </div>
      <Container>
        <Box textAlign="center">
          <div
            style={{
              background: "transparent",
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 2, sm: 4 },
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  backgroundColor: lightBg2,
                  borderRadius: { xs: "20px", sm: "20px" },
                  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                }}
              >
                <CardContent sx={{ p: { xs: 3, sm: 3 } }}>
                  {!isLoading && isSuccess ? (
                    <Box
                      component="form"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: 2,
                        height: "200px",
                      }}
                    >
                      <CheckCircle sx={{ fontSize: 65, color: "green" }} />
                      <Typography
                        sx={{
                          color: "#6366f1",
                          fontSize: "16px",
                        }}
                      >
                        {response}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "#202020", textAlign: "center", mt: 1 }}
                      >
                        {"Go to"}{" "}
                        <Button
                          variant="text"
                          onClick={() => navigate("/login")}
                          sx={{
                            color: "#6366f1",
                            textDecoration: "underline",
                            textTransform: "none",
                            p: 0,
                            minWidth: "auto",
                            "&:hover": { backgroundColor: "transparent" },
                          }}
                        >
                          portal
                        </Button>
                      </Typography>
                    </Box>
                  ) : !isLoading && !isSuccess ? (
                    <Box
                      component="form"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: 2,
                        height: "200px",
                      }}
                    >
                      <CancelCircle sx={{ fontSize: 65, color: "red" }} />
                      <Typography
                        sx={{
                          color: "#6366f1",
                          fontSize: "16px",
                        }}
                      >
                        {response}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      component="form"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: 2,
                        height: "200px",
                      }}
                    >
                      <CircularProgress sx={{ fontSize: 65, color: "#6366f1" }} />
                      <Typography
                        sx={{
                          color: "#6366f1",
                          fontSize: "16px",
                        }}
                      >
                        Verifying...
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Box>
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default EmailVerification;
